<template>
  <div class="cl-wrap-switch">
    <input class="d-none" type="checkbox" :id="id">
    <label class="form-check-label" :for="id">
      <div></div>
      <span class="fw-bold">{{name}}</span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    name: String
  }
}
</script>

<style>

</style>